import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {}

    toggleShow = () => {
        if (!this.element.classList.contains('active')) this.show();
        else this.hide();
    }

    show() {
        this.element.classList.add('active');
    }

    hide() {
        this.element.classList.remove('active');
    }
}